import QueryEdgeNode from '../models/query-edge-node.model';

export default function getNodes<Type>(data: QueryEdgeNode<Type>) {
    return data?.edges.map((item) => item.node);
}
